var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"x-swipe-container",class:_vm.classes},[_c('div',{staticClass:"fixed swipable",style:(_vm.contentStyle),on:{"click":_vm.onClickFixed}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }